export const AGENTFORCE_ARTIFACT_CODE = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Customer Service Agentforce Assessment</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', sans-serif;
            background: #ffffff;
            color: #37352f;
            line-height: 1.6;
        }

        .header {
            background: #ffffff;
            border-bottom: 1px solid #e9e9e7;
            padding: 32px 0;
        }

        .header-content {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 40px;
        }

        .header-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 24px;
        }

        .logo {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 0.9rem;
            font-weight: 600;
            color: #6b6b6b;
        }

        .logo-icon {
            padding: 6px 12px;
            background: #ffeb99;
            border-radius: 6px;
            color: #37352f;
            font-weight: 700;
            font-size: 0.75rem;
            letter-spacing: 0.5px;
        }

        .header-meta {
            font-size: 0.875rem;
            color: #9b9a97;
        }

        .header h1 {
            font-size: 2.5rem;
            font-weight: 700;
            color: #37352f;
            margin-bottom: 8px;
            letter-spacing: -0.02em;
        }

        .header-subtitle {
            font-size: 1.125rem;
            color: #6b6b6b;
            font-weight: 400;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 40px;
        }

        /* Executive Summary */
        .executive-summary {
            background: #f7f6f3;
            border-radius: 8px;
            padding: 32px;
            margin-bottom: 32px;
        }

        .summary-title {
            font-size: 1.5rem;
            font-weight: 700;
            color: #37352f;
            margin-bottom: 24px;
            letter-spacing: -0.01em;
        }

        .summary-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
            gap: 16px;
        }

        .summary-card {
            background: #ffffff;
            border-radius: 6px;
            padding: 20px;
            border: 1px solid #e9e9e7;
        }

        .summary-card-header {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 12px;
        }

        .summary-icon {
            font-size: 1.25rem;
        }

        .summary-card-title {
            font-size: 0.95rem;
            font-weight: 600;
            color: #37352f;
        }

        .summary-card-desc {
            font-size: 0.875rem;
            color: #6b6b6b;
            line-height: 1.6;
        }

        /* Navigation */
        .nav-tabs {
            display: flex;
            gap: 8px;
            margin-bottom: 32px;
            border-bottom: 1px solid #e9e9e7;
            padding-bottom: 0;
        }

        .nav-tab {
            padding: 8px 12px;
            background: transparent;
            border: none;
            border-radius: 4px 4px 0 0;
            cursor: pointer;
            font-size: 0.875rem;
            font-weight: 500;
            color: #6b6b6b;
            transition: all 0.2s;
            position: relative;
        }

        .nav-tab:hover {
            background: #f7f6f3;
            color: #37352f;
        }

        .nav-tab.active {
            color: #37352f;
            background: transparent;
        }

        .nav-tab.active::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            height: 2px;
            background: #37352f;
        }

        /* Tab Content */
        .tab-content {
            display: none;
        }

        .tab-content.active {
            display: block;
            animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
        }

        /* Agent Cards */
        .agent-grid {
            display: grid;
            gap: 24px;
        }

        .agent-card {
            background: #ffffff;
            border: 1px solid #e9e9e7;
            border-radius: 8px;
            padding: 32px;
            transition: all 0.2s;
        }

        .agent-card:hover {
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        }

        .agent-header {
            display: flex;
            justify-content: space-between;
            align-items: start;
            margin-bottom: 16px;
            gap: 20px;
        }

        .agent-title {
            font-size: 1.5rem;
            color: #37352f;
            font-weight: 700;
            letter-spacing: -0.01em;
        }

        .priority-badge {
            padding: 4px 10px;
            border-radius: 4px;
            font-size: 0.75rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            background: #f7f6f3;
            color: #37352f;
            white-space: nowrap;
        }

        .priority-high {
            background: #ffe3e3;
            color: #c9302c;
        }

        .priority-medium {
            background: #e3f2fd;
            color: #1976d2;
        }

        .agent-desc {
            color: #6b6b6b;
            line-height: 1.7;
            margin-bottom: 24px;
            font-size: 1rem;
        }

        .agent-section {
            background: #f7f6f3;
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 20px;
        }

        .section-title {
            font-size: 0.8rem;
            font-weight: 700;
            color: #37352f;
            margin-bottom: 16px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .topic-item, .action-item-card {
            background: #ffffff;
            border-radius: 6px;
            padding: 16px;
            margin-bottom: 12px;
            border: 1px solid #e9e9e7;
        }

        .topic-header {
            display: flex;
            align-items: start;
            gap: 10px;
        }

        .topic-icon {
            color: #fbbf24;
            font-size: 0.875rem;
            margin-top: 2px;
        }

        .topic-name {
            font-weight: 600;
            color: #37352f;
            font-size: 0.95rem;
            margin-bottom: 6px;
        }

        .topic-desc {
            font-size: 0.875rem;
            color: #6b6b6b;
            line-height: 1.6;
        }

        .action-type {
            display: inline-block;
            padding: 3px 8px;
            background: #37352f;
            color: white;
            border-radius: 4px;
            font-size: 0.7rem;
            font-weight: 600;
            margin-top: 8px;
            letter-spacing: 0.3px;
        }

        .flow-name {
            font-family: 'SF Mono', Monaco, 'Courier New', monospace;
            font-size: 0.85rem;
            color: #37352f;
            background: #f7f6f3;
            padding: 2px 6px;
            border-radius: 3px;
        }

        .workflow-consolidation {
            background: #ffffff;
            border: 1px solid #e9e9e7;
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 20px;
        }

        .consolidation-title {
            font-size: 0.8rem;
            font-weight: 700;
            color: #37352f;
            margin-bottom: 16px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .consolidation-item {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 10px;
            font-size: 0.875rem;
            color: #37352f;
            flex-wrap: wrap;
        }

        .arrow {
            color: #9b9a97;
            font-weight: 700;
        }

        .agent-footer {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
            gap: 12px;
            margin-top: 24px;
            padding-top: 24px;
            border-top: 1px solid #e9e9e7;
        }

        .metric-box {
            text-align: center;
            padding: 16px;
            background: #f7f6f3;
            border-radius: 6px;
        }

        .metric-value {
            font-size: 1.75rem;
            font-weight: 700;
            color: #37352f;
            letter-spacing: -0.02em;
        }

        .metric-label {
            font-size: 0.75rem;
            color: #6b6b6b;
            margin-top: 4px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        /* Table */
        .data-table {
            width: 100%;
            background: #ffffff;
            border: 1px solid #e9e9e7;
            border-radius: 8px;
            overflow: hidden;
        }

        .data-table thead {
            background: #f7f6f3;
        }

        .data-table th {
            padding: 12px 16px;
            text-align: left;
            font-weight: 600;
            font-size: 0.8rem;
            color: #37352f;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .data-table td {
            padding: 14px 16px;
            border-top: 1px solid #e9e9e7;
            font-size: 0.9rem;
        }

        .data-table tbody tr:hover {
            background: #f7f6f3;
        }

        .tag {
            display: inline-block;
            padding: 4px 10px;
            background: #f7f6f3;
            color: #37352f;
            border-radius: 4px;
            font-size: 0.75rem;
            font-weight: 600;
        }

        /* Roadmap */
        .timeline {
            position: relative;
            padding-left: 40px;
        }

        .timeline::before {
            content: '';
            position: absolute;
            left: 12px;
            top: 0;
            bottom: 0;
            width: 2px;
            background: #e9e9e7;
        }

        .phase {
            background: #ffffff;
            border: 1px solid #e9e9e7;
            border-radius: 8px;
            padding: 24px;
            margin-bottom: 24px;
            position: relative;
        }

        .phase::before {
            content: '';
            position: absolute;
            left: -33px;
            top: 28px;
            width: 12px;
            height: 12px;
            background: #37352f;
            border-radius: 50%;
            border: 3px solid white;
        }

        .phase-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }

        .phase-title {
            font-size: 1.25rem;
            font-weight: 700;
            color: #37352f;
            letter-spacing: -0.01em;
        }

        .phase-duration {
            background: #f7f6f3;
            color: #37352f;
            padding: 6px 12px;
            border-radius: 4px;
            font-size: 0.8rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .phase-item {
            padding: 14px;
            background: #f7f6f3;
            border-radius: 6px;
            margin-bottom: 10px;
        }

        .phase-item-name {
            font-weight: 600;
            color: #37352f;
            margin-bottom: 6px;
        }

        .phase-item-desc {
            font-size: 0.875rem;
            color: #6b6b6b;
            line-height: 1.6;
        }

        /* Buttons */
        .btn-group {
            display: flex;
            gap: 12px;
            margin-top: 32px;
        }

        .btn {
            padding: 10px 20px;
            border-radius: 6px;
            font-weight: 600;
            cursor: pointer;
            border: 1px solid #e9e9e7;
            font-size: 0.875rem;
            transition: all 0.2s;
        }

        .btn-primary {
            background: #37352f;
            color: white;
            border-color: #37352f;
        }

        .btn-primary:hover {
            background: #2c2a26;
        }

        .btn-secondary {
            background: white;
            color: #37352f;
        }

        .btn-secondary:hover {
            background: #f7f6f3;
        }

        .info-box {
            background: #f7f6f3;
            border-radius: 6px;
            padding: 20px;
            margin-top: 24px;
            border: 1px solid #e9e9e7;
        }

        .info-title {
            font-weight: 600;
            color: #37352f;
            margin-bottom: 10px;
            font-size: 0.95rem;
        }

        .info-text {
            color: #6b6b6b;
            line-height: 1.7;
            font-size: 0.9rem;
        }
    </style>
</head>
<body>
    <div class="header">
        <div class="header-content">
            <div class="header-top">
                <div class="logo">
                    <div class="logo-icon">SWEEP</div>
                    AGENTFORCE ASSESSMENT
                </div>
                <div class="header-meta">Customer Service • October 2025</div>
            </div>
            <h1>Strategic AI Implementation Plan</h1>
            <div class="header-subtitle">Transform customer service with intelligent automation</div>
        </div>
    </div>

    <div class="container">
        <!-- Executive Summary -->
        <div class="executive-summary">
            <h2 class="summary-title">Workflow Consolidation Opportunities</h2>
            <div class="summary-grid">
                <div class="summary-card">
                    <div class="summary-card-header">
                        <span class="summary-icon">🎯</span>
                        <div class="summary-card-title">Intelligent Classification</div>
                    </div>
                    <div class="summary-card-desc">Consolidate 11 classification workflows into Flow-powered agent actions</div>
                </div>
                <div class="summary-card">
                    <div class="summary-card-header">
                        <span class="summary-icon">⚡</span>
                        <div class="summary-card-title">SLA Monitoring</div>
                    </div>
                    <div class="summary-card-desc">Transform Process Builder into predictive milestone tracking</div>
                </div>
                <div class="summary-card">
                    <div class="summary-card-header">
                        <span class="summary-icon">🔄</span>
                        <div class="summary-card-title">Development Sync</div>
                    </div>
                    <div class="summary-card-desc">Enhance existing JIRA trigger with autonomous status management</div>
                </div>
                <div class="summary-card">
                    <div class="summary-card-header">
                        <span class="summary-icon">📊</span>
                        <div class="summary-card-title">Email Routing</div>
                    </div>
                    <div class="summary-card-desc">Merge 20+ email rules into unified Email-to-Case + agent pipeline</div>
                </div>
            </div>
        </div>

        <!-- Navigation -->
        <div class="nav-tabs">
            <button class="nav-tab active" onclick="switchTab('agents')">Agent Recommendations</button>
            <button class="nav-tab" onclick="switchTab('current')">Current State</button>
            <button class="nav-tab" onclick="switchTab('roadmap')">Implementation Roadmap</button>
        </div>

        <!-- Agents Tab -->
        <div class="tab-content active" id="agents">
            <div class="agent-grid">
                <!-- Agent 1 -->
                <div class="agent-card">
                    <div class="agent-header">
                        <h3 class="agent-title">Service Agent: Case Classification & Routing</h3>
                        <span class="priority-badge priority-high">Foundation</span>
                    </div>
                    <p class="agent-desc">Build a custom Service Agent that automatically classifies incoming cases and intelligently routes them to the appropriate support team. This agent will leverage your existing taxonomy while consolidating scattered workflow logic into Flow-powered actions.</p>
                    
                    <div class="workflow-consolidation">
                        <div class="consolidation-title">Workflow Consolidation</div>
                        <div class="consolidation-item">
                            <span>11 Classification Workflows</span>
                            <span class="arrow">→</span>
                            <span class="flow-name">Case_Intelligence_Flow</span>
                            <span class="arrow">→</span>
                            <span>3 Agent Actions</span>
                        </div>
                        <div class="consolidation-item">
                            <span>11 Effort Calculation Rules</span>
                            <span class="arrow">→</span>
                            <span class="flow-name">Effort_Estimation_Flow</span>
                            <span class="arrow">→</span>
                            <span>1 Agent Action</span>
                        </div>
                    </div>

                    <div class="agent-section">
                        <div class="section-title">Topics & Instructions</div>
                        <div class="topic-item">
                            <div class="topic-header">
                                <span class="topic-icon">▸</span>
                                <div>
                                    <div class="topic-name">Case Classification</div>
                                    <div class="topic-desc">Scope: Analyze case description and subject to determine Type, Reason, Module, and Priority from your 156-type taxonomy</div>
                                </div>
                            </div>
                        </div>
                        <div class="topic-item">
                            <div class="topic-header">
                                <span class="topic-icon">▸</span>
                                <div>
                                    <div class="topic-name">Intelligent Routing</div>
                                    <div class="topic-desc">Scope: Route cases to optimal Support Office based on language, expertise, and current queue load across 12 global offices</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="agent-section">
                        <div class="section-title">Agent Actions (Flow-Powered)</div>
                        <div class="action-item-card">
                            <div class="topic-header">
                                <span class="topic-icon">⚙️</span>
                                <div>
                                    <div class="topic-name">Classify_And_Route</div>
                                    <div class="topic-desc">Updates: Case Type, Case Reason, Priority, Severity, Module, Support Office, Owner (Queue Assignment)</div>
                                    <span class="action-type">Autolaunched Flow</span>
                                </div>
                            </div>
                        </div>
                        <div class="action-item-card">
                            <div class="topic-header">
                                <span class="topic-icon">⚙️</span>
                                <div>
                                    <div class="topic-name">Calculate_Effort</div>
                                    <div class="topic-desc">Updates: Effort Minutes based on case type complexity matrix</div>
                                    <span class="action-type">Autolaunched Flow</span>
                                </div>
                            </div>
                        </div>
                        <div class="action-item-card">
                            <div class="topic-header">
                                <span class="topic-icon">⚙️</span>
                                <div>
                                    <div class="topic-name">Assign_Initial_Response</div>
                                    <div class="topic-desc">Creates: Personalized response template based on case type and customer tier</div>
                                    <span class="action-type">Prompt Template</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="agent-footer">
                        <div class="metric-box">
                            <div class="metric-value">22</div>
                            <div class="metric-label">Workflows</div>
                        </div>
                        <div class="metric-box">
                            <div class="metric-value">3</div>
                            <div class="metric-label">Topics</div>
                        </div>
                        <div class="metric-box">
                            <div class="metric-value">3</div>
                            <div class="metric-label">Actions</div>
                        </div>
                    </div>
                </div>

                <!-- Agent 2 -->
                <div class="agent-card">
                    <div class="agent-header">
                        <h3 class="agent-title">Service Agent: SLA & Milestone Management</h3>
                        <span class="priority-badge priority-high">High Impact</span>
                    </div>
                    <p class="agent-desc">Deploy an autonomous agent that continuously monitors SLA milestones and proactively escalates at-risk cases. Built on the Atlas Reasoning Engine, this agent will predict potential breaches and trigger intelligent escalation workflows.</p>
                    
                    <div class="workflow-consolidation">
                        <div class="consolidation-title">Workflow Consolidation</div>
                        <div class="consolidation-item">
                            <span>SLA_Milestone_Manager (Process Builder)</span>
                            <span class="arrow">→</span>
                            <span class="flow-name">Milestone_Monitor_Flow</span>
                            <span class="arrow">→</span>
                            <span>2 Agent Actions</span>
                        </div>
                    </div>

                    <div class="agent-section">
                        <div class="section-title">Topics & Instructions</div>
                        <div class="topic-item">
                            <div class="topic-header">
                                <span class="topic-icon">▸</span>
                                <div>
                                    <div class="topic-name">Milestone Tracking</div>
                                    <div class="topic-desc">Scope: Monitor First Response and Resolution milestones across all priority levels, calculate business hours-adjusted age</div>
                                </div>
                            </div>
                        </div>
                        <div class="topic-item">
                            <div class="topic-header">
                                <span class="topic-icon">▸</span>
                                <div>
                                    <div class="topic-name">Predictive Escalation</div>
                                    <div class="topic-desc">Scope: Identify cases approaching SLA breach (within 2 hours) and execute escalation protocol</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="agent-section">
                        <div class="section-title">Agent Actions (Flow-Powered)</div>
                        <div class="action-item-card">
                            <div class="topic-header">
                                <span class="topic-icon">⚙️</span>
                                <div>
                                    <div class="topic-name">Update_Milestone_Status</div>
                                    <div class="topic-desc">Updates: Milestone Status, SLA Exit Time, Case Age (Business Hours), Stopped/Paused Timer</div>
                                    <span class="action-type">Autolaunched Flow</span>
                                </div>
                            </div>
                        </div>
                        <div class="action-item-card">
                            <div class="topic-header">
                                <span class="topic-icon">⚙️</span>
                                <div>
                                    <div class="topic-name">Escalate_At_Risk_Case</div>
                                    <div class="topic-desc">Creates: Case Escalation record, sends Slack/email alerts, reassigns to senior queue</div>
                                    <span class="action-type">Autolaunched Flow</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="agent-footer">
                        <div class="metric-box">
                            <div class="metric-value">8</div>
                            <div class="metric-label">Milestones</div>
                        </div>
                        <div class="metric-box">
                            <div class="metric-value">2</div>
                            <div class="metric-label">Topics</div>
                        </div>
                        <div class="metric-box">
                            <div class="metric-value">24/7</div>
                            <div class="metric-label">Autonomous</div>
                        </div>
                    </div>
                </div>

                <!-- Agent 3 -->
                <div class="agent-card">
                    <div class="agent-header">
                        <h3 class="agent-title">Custom Agent: Development Sync</h3>
                        <span class="priority-badge priority-medium">Enhancement</span>
                    </div>
                    <p class="agent-desc">Enhance your existing JIRA integration by adding intelligent, bi-directional synchronization. This custom agent will work alongside your current Apex trigger to provide autonomous status management and development progress updates.</p>
                    
                    <div class="workflow-consolidation">
                        <div class="consolidation-title">Enhancement Strategy</div>
                        <div class="consolidation-item">
                            <span>Existing JIRA Apex Trigger</span>
                            <span class="arrow">+</span>
                            <span class="flow-name">JIRA_Sync_Flow</span>
                            <span class="arrow">→</span>
                            <span>Agent Actions</span>
                        </div>
                    </div>

                    <div class="agent-section">
                        <div class="section-title">Topics & Instructions</div>
                        <div class="topic-item">
                            <div class="topic-header">
                                <span class="topic-icon">▸</span>
                                <div>
                                    <div class="topic-name">Issue Synchronization</div>
                                    <div class="topic-desc">Scope: Create JIRA issues for Bug, Feature Request, and Code Fix cases; sync status changes bidirectionally</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="agent-section">
                        <div class="section-title">Agent Actions</div>
                        <div class="action-item-card">
                            <div class="topic-header">
                                <span class="topic-icon">⚙️</span>
                                <div>
                                    <div class="topic-name">Sync_Development_Status</div>
                                    <div class="topic-desc">Updates: JIRA Status ↔ Salesforce Status, Development Progress field, adds timeline entry</div>
                                    <span class="action-type">Flow + MuleSoft API</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="agent-footer">
                        <div class="metric-box">
                            <div class="metric-value">1</div>
                            <div class="metric-label">Topic</div>
                        </div>
                        <div class="metric-box">
                            <div class="metric-value">Real-time</div>
                            <div class="metric-label">Sync</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="info-box">
                <div class="info-title">Email-to-Case Strategy</div>
                <p class="info-text">The 20+ email workflow rules will be optimized through Email-to-Case service configuration rather than Agentforce. Once cases are created from email, the Classification Agent will handle intelligent routing through its Flow-powered actions.</p>
            </div>
        </div>

        <!-- Current State Tab -->
        <div class="tab-content" id="current">
            <table class="data-table">
                <thead>
                    <tr>
                        <th>Current Automation</th>
                        <th>Type</th>
                        <th>Complexity</th>
                        <th>Agent Strategy</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Case Classification</strong></td>
                        <td><span class="tag">11 Workflow Rules</span></td>
                        <td>156 Types, 31 Reasons</td>
                        <td>Consolidate → Classification Agent Actions</td>
                    </tr>
                    <tr>
                        <td><strong>Email Processing</strong></td>
                        <td><span class="tag">20+ Workflow Rules</span></td>
                        <td>6 Origin Channels</td>
                        <td>Optimize via Email-to-Case Config</td>
                    </tr>
                    <tr>
                        <td><strong>SLA Management</strong></td>
                        <td><span class="tag">1 Process Builder</span></td>
                        <td>8 Milestone Types</td>
                        <td>Transform → SLA Agent Actions</td>
                    </tr>
                    <tr>
                        <td><strong>Effort Calculation</strong></td>
                        <td><span class="tag">11 Workflow Rules</span></td>
                        <td>Time-based Logic</td>
                        <td>Consolidate → Flow Action</td>
                    </tr>
                    <tr>
                        <td><strong>JIRA Integration</strong></td>
                        <td><span class="tag">1 Apex Trigger</span></td>
                        <td>Bi-directional Sync</td>
                        <td>Enhance → Agent + Flow + API</td>
                    </tr>
                </tbody>
            </table>

            <div class="info-box" style="margin-top: 24px;">
                <div class="info-title">Current Architecture</div>
                <p class="info-text">
                    Your org contains <strong>156 Case Types</strong> with <strong>31 Case Reasons</strong> requiring contextual understanding, 
                    <strong>18 Priority Levels</strong> for granular escalation, <strong>21 Status Values</strong> managing complex workflows, 
                    and <strong>12 Global Support Offices</strong> with language and timezone requirements. The 34 active automation elements 
                    are prime candidates for consolidation into Flow-powered agent actions.
                </p>
            </div>
        </div>

        <!-- Roadmap Tab -->
        <div class="tab-content" id="roadmap">
            <div class="timeline">
                <div class="phase">
                    <div class="phase-header">
                        <h3 class="phase-title">Phase 1: Foundation & Flow Development</h3>
                        <span class="phase-duration">Weeks 1-4</span>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">Build Core Flows</div>
                        <div class="phase-item-desc">Create Case_Intelligence_Flow, Effort_Estimation_Flow, Assign_Initial_Response prompt template</div>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">Configure Service Agent</div>
                        <div class="phase-item-desc">Set up Classification & Routing topics with natural language instructions, map to Flow actions</div>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">Test in Agent Builder</div>
                        <div class="phase-item-desc">Use Agentforce Testing Center to validate topic classification and action execution</div>
                    </div>
                </div>

                <div class="phase">
                    <div class="phase-header">
                        <h3 class="phase-title">Phase 2: SLA Intelligence</h3>
                        <span class="phase-duration">Weeks 5-8</span>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">Migrate Process Builder Logic</div>
                        <div class="phase-item-desc">Transform SLA_Milestone_Manager into Milestone_Monitor_Flow with business hours calculations</div>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">Deploy SLA Agent</div>
                        <div class="phase-item-desc">Configure Milestone Tracking and Predictive Escalation topics with Flow actions</div>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">Enable Enriched Event Logs</div>
                        <div class="phase-item-desc">Activate logging in Agent Details for monitoring and refinement</div>
                    </div>
                </div>

                <div class="phase">
                    <div class="phase-header">
                        <h3 class="phase-title">Phase 3: Integration & Optimization</h3>
                        <span class="phase-duration">Weeks 9-12</span>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">JIRA Sync Enhancement</div>
                        <div class="phase-item-desc">Build JIRA_Sync_Flow with MuleSoft API integration, configure Development Sync agent</div>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">Email-to-Case Optimization</div>
                        <div class="phase-item-desc">Streamline email service configuration, route to Classification Agent</div>
                    </div>
                    <div class="phase-item">
                        <div class="phase-item-name">Deploy & Monitor</div>
                        <div class="phase-item-desc">Channel activation, Omni Supervisor setup for agent monitoring, feedback iteration</div>
                    </div>
                </div>
            </div>

            <div class="btn-group">
                <button class="btn btn-primary" onclick="alert('Generating detailed implementation guide with Flow specifications...')">Download Technical Guide</button>
                <button class="btn btn-secondary" onclick="alert('Scheduling Agent Builder workshop...')">Schedule Workshop</button>
            </div>
        </div>
    </div>

    <script>
        function switchTab(tabId) {
            document.querySelectorAll('.nav-tab').forEach(t => t.classList.remove('active'));
            document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
            event.target.classList.add('active');
            document.getElementById(tabId).classList.add('active');
        }
    </script>
</body>
</html>

`;
